import { rest } from 'catering/api';
import { buildApiEndpoint, withQueryString } from 'helpers/apiHelpers';

export const CART_BASE_ENDPOINT = buildApiEndpoint('/api/catering/cart');

export const CART_UPDATE_ENDPOINT = `${CART_BASE_ENDPOINT}/`;
export const CART_ADD_ENDPOINT = `${CART_BASE_ENDPOINT}/add/`;
export const CART_VALIDATE_ENDPOINT = `${CART_BASE_ENDPOINT}/validate/`;
export const CART_EMPTY_ENDPOINT = `${CART_BASE_ENDPOINT}/items/`;
export const CART_RESET_PICKUP_ADDRESS_ENDPOINT = `${CART_BASE_ENDPOINT}/reset-pickup-address`;
export const CART_PROMOTION_ENDPOINT = `${CART_BASE_ENDPOINT}/promotion/`;

export const getCartEndpointWithQueryParams = (queryParams = {}) =>
  withQueryString(CART_BASE_ENDPOINT, queryParams);

export const CART_GET_ENDPOINT = getCartEndpointWithQueryParams();

export const getRemoveCartItemEndpoint = cartItemId =>
  `${CART_BASE_ENDPOINT}/${cartItemId}/`;
export const getUpdateCartItemEndpoint = cartItemId =>
  `${CART_BASE_ENDPOINT}/${cartItemId}/`;

export async function getCart(queryParams = {}) {
  return rest.get(getCartEndpointWithQueryParams(queryParams));
}

export async function createCartPromotion(promoCode) {
  const data = {
    promo_code: promoCode
  };
  return rest.post(CART_PROMOTION_ENDPOINT, {
    data
  });
}

export async function validateCart() {
  return rest.get(CART_VALIDATE_ENDPOINT);
}

export async function updateCart(data) {
  return rest.patch(CART_UPDATE_ENDPOINT, {
    data
  });
}

export async function addToCart(data) {
  return rest.patch(CART_ADD_ENDPOINT, {
    data
  });
}

export async function emptyCart() {
  return rest.delete(CART_EMPTY_ENDPOINT);
}

export async function removeCartItem(cartItemId) {
  return rest.delete(getRemoveCartItemEndpoint(cartItemId));
}

export async function updateCartItem(cartItemId, data) {
  return rest.patch(getUpdateCartItemEndpoint(cartItemId), { data });
}

export async function resetPickupAddress() {
  return rest.get(CART_RESET_PICKUP_ADDRESS_ENDPOINT);
}

export const getCateringProductPricePreviewEndpoint = productId =>
  `${CART_BASE_ENDPOINT}/product/price_preview/${productId}`;
